import { getNextItemStartingWith } from '../../../item';

export function traverseItemsByCharacter(key, state) {
	const { activeItem, items } = state;

	return getNextItemStartingWith(items, activeItem, key);
}
